import React from 'react';
import RenderAgeCell from './RenderAgeCell';

interface CellProps {
  value: Number;
  getValue: Function;
}

interface AssetAgeProps {
  cell: CellProps;
}

function AssetAge(props: AssetAgeProps) {
  const { cell } = props;
  let value = null;
  // Temp fix for asset super table 0 value
  if (cell?.getValue) {
    value = cell.getValue();
  } else {
    value = cell.value;
  }

  return (
    <div>
      <RenderAgeCell year={value} />
    </div>
  );
}

export default AssetAge;
